var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)+" "),_c('div',{staticClass:"animated infinite rubberBand delay-2s animated color-primary-bghover check-menu",on:{"click":_vm.showTmm}})])}
var staticRenderFns = []

export { render, staticRenderFns }